var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.31 -366.42)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M33.65,366.79c-.23-.23-.53-.37-.86-.37-.35,0-.66.14-.88.37-.23.23-.35.53-.35.86v.16c-1.03.27-1.93.86-2.65,1.69-.99,1.11-1.58,2.65-1.6,4.36-.02,3.89-.56,4.54-1.09,5.18-.33.37-.66.76-.9,1.58-.02.06-.02.1-.02.16,0,.23.19.43.43.43h4.95c0,.58.23,1.11.62,1.48.39.39.9.64,1.5.64s1.11-.25,1.5-.64c.37-.37.62-.9.62-1.48h4.95v-.02h.12c.21-.08.35-.31.29-.53-.27-.86-.58-1.23-.9-1.62-.56-.64-1.09-1.3-1.11-5.18,0-1.71-.62-3.25-1.6-4.36-.72-.82-1.62-1.42-2.65-1.69.02-.06.02-.1.02-.16,0-.33-.14-.64-.37-.86Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarNotification);
export default __webpack_public_path__ + "static/media/sidebar_notification.d63146c877b06729bd903cddabc1f208.svg";
export { ForwardRef as ReactComponent };